import angular from "angular";

angular
    .module('app')
    .component('userDevicesList', {
        template: require('./user-devices-list.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 10;

    $ctrl.$onInit = function () {
        $ctrl.user = $ctrl.resolve.user;
        $ctrl.getDevicesList();
    };

    $ctrl.getDevicesList = function () {
        $ctrl.loading = true;
        $http
            .get(`/admin/users/${$ctrl.user.id}/get-devices-list`, {
                params: {
                    page: $ctrl.page,
                    per_page:$ctrl.perPage,
                }
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.devices = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {
                    $ctrl.loading = false;
                }
            );
    };
}
